import { useMemo } from 'react';

import { useDocumentDisplayConfig } from '../DocumentDisplayConfig/DocumentDisplayConfigContext';

const PRICE_FIELD_PATHS = [
  'item.unit_price',
  'total_amount',
  'tax_percentage',
  'line_gross_amount',
  'line_tax_amount',
  'line_charge_amount',
  'line_allowance_amount',
  'line_net_amount',
  'line_allowances_charges',
  'line_due_amount',
];

export const useHidePriceColumns = (config: Array<any>) => {
  const { showPriceFields } = useDocumentDisplayConfig();

  return useMemo(() => {
    if (showPriceFields) {
      return config;
    }

    return config.filter((field) => !isPriceField(field.path));
  }, [config, showPriceFields]);
};

const isPriceField = (path: string) =>
  PRICE_FIELD_PATHS.some((pricePath) => path === pricePath || path.endsWith(`.${pricePath}`));
